import React, { useEffect, useState } from "react";
import './styles.css'
import Loader from '../../../../components/loader/loader.component'
import { useDispatch, useSelector } from 'react-redux'
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isNull, screenCaptureAnalytics } from "../../../../utils/Utils";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { userBusinessListRequest } from '../../../../redux/business/business.action'
import { useNavigate } from 'react-router-dom';
import { ROUTES, API_CONSTANTS, APP_CONSTANTS } from "../../../../utils/AppConstants";
import moment from "moment";
import CommonScreenContent from "../../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../../components/label/screen-label/screenLabel";

const BusinessListScreen = props => {
    const { user } = useSelector(state => state.user)
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();

    useEffect(() => {
        fetchBusinessList()
    }, [])

    const fetchBusinessList = () => {
        setLoading(true)
        const data1 = {
            userId: user.data.userDetails.userId
        }
        dispatch(userBusinessListRequest(data1))
    }

    useEffect(() => {
        if (!isNull(userBusinessListSuccess)) {
            setLoading(false)
        } else if (!isNull(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    const handleCardClick = (element) => {

    }

    const addBusinessClickHandle = () => {
        navigate(ROUTES.business.addBusiness)
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Business' />
                <div className="table-scroll-container">
                    {!isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <table class="table table-hover mt-4">
                        <thead>
                            <tr>
                                <th scope="col" >Name</th>
                                <th scope="col" className="text-center">Status</th>
                                <th scope="col" className="text-center">Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {userBusinessListSuccess.data.map(element => (
                                <tr className="loc-table-row-container" onClick={() => { handleCardClick(element) }}>
                                    <td >{element.businessName}</td>
                                    <td className="text-center">
                                        <div className={element.isActive === true ? 'active' : 'in-active'}>{element.isActive === true ? 'Active' : 'In-Active'}</div>
                                    </td>
                                    <td className="text-center">{moment(element.createdOn).utc().format('DD MMM YYYY')}</td>
                                </tr>
                            ))}

                        </tbody>
                    </table>}
                </div>
                {!isEmpty(userBusinessListError) && <div className="content-error">{userBusinessListError.message}</div>}
                <div className="vl-fab-container" onClick={() => addBusinessClickHandle()}>
                    <img src={require('../../../../assets/plus_icon.png')} className="vl-fab-icon" />
                </div>
            </CommonScreenContent>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default BusinessListScreen